export const NOTIFICATION_TYPES = Object.freeze({
    GATEWAY_OFFLINE: "GATEWAY_OFFLINE",
    DEVICE_OFFLINE: "DEVICE_OFFLINE",
    BATTERY_STATUS_LOW: "BATTERY_STATUS_LOW",
    DEVICE_OVERVIEW: "DEVICE_OVERVIEW",
    INTEGRATION_LNS: "INTEGRATION_LNS",
} as const);

export const INTERVALS = Object.freeze({
    IMMEDIATELY: "IMMEDIATELY",
    DAILY: "DAILY",
    MONDAY: "MONDAY",
    TUESDAY: "TUESDAY",
    WEDNESDAY: "WEDNESDAY",
    THURSDAY: "THURSDAY",
    FRIDAY: "FRIDAY",
    SATURDAY: "SATURDAY",
    SUNDAY: "SUNDAY",
} as const);
